import React from 'react'
import { MessageCardTimeline, MessageCategories } from '@pandiafi/components'
import { useTranslation } from 'react-i18next'

import { MessageThread } from '../../../common/validations/residentMessageTimelineSchema'
import { ThreadStack } from './ThreadStack'
import { getReadOnlyMessageCategoryOptions } from './utils'

import { useAPIGetResidentMessageCategories } from 'api/apiHooks/useAPIGetResidentMessageCategories'

export const MessageTimeline = ({
  messages,
  onViewThread,
}: {
  messages: MessageThread[]
  onViewThread: (uuid: string) => void
}) => {
  const { t, i18n } = useTranslation(['messages'])
  const { data } = useAPIGetResidentMessageCategories()
  const selectableCategories = data?.categories ?? []
  const hasSelectableCategories = Boolean(selectableCategories.length)

  return (
    <MessageCardTimeline>
      {messages
        .filter((thread) => thread.entries.length > 0)
        .map((thread) => (
          <ThreadStack
            key={thread.id}
            thread={thread}
            onViewThread={onViewThread}
            open={false}
            header={
              thread.messageCategory || hasSelectableCategories ? (
                <MessageCategories
                  value={
                    thread.messageCategory
                      ? String(thread.messageCategory.id)
                      : ''
                  }
                  categories={getReadOnlyMessageCategoryOptions(
                    thread.messageCategory,
                    selectableCategories,
                    i18n.language,
                    t('messages:form.noCategory')
                  )}
                  disabled
                />
              ) : undefined
            }
          />
        ))}
    </MessageCardTimeline>
  )
}
